<template>
  <div v-bind="$attrs">
    <v-window-item :disabled="disabled" data-testid="so-tab" :eager="eager">
      <slot />
    </v-window-item>
  </div>
</template>

<script lang="ts">
  import { IconStringWithModifiers } from "@/types/Icon"
  import { defineComponent, PropType } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      title: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      eager: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String as PropType<IconStringWithModifiers>,
        default: "",
      },
      iconColor: {
        type: String,
        default: "",
      },
    },
  })
</script>
